import script from "./SimpleDrag.vue?vue&type=script&setup=true&lang=js"
export * from "./SimpleDrag.vue?vue&type=script&setup=true&lang=js"

import "./SimpleDrag.vue?vue&type=style&index=0&id=f1719b00&lang=css"

const __exports__ = script;

export default __exports__